import { PremiumUpgradeButtonIcon } from "@/assets/svg-icons/svg-icons";
import Button from ".";
import { useZStore } from "@/utils/z-store";
import cn from "@/utils/cn";

const PremiumUpgradeButton = ({ className }: { className?: string }) => {
  const { actions } = useZStore();
  return (
    <Button
      className={cn(
        "h-[18px] w-[58px] space-x-[3px] rounded-[5px] px-0",
        className,
      )}
      onClick={() => {
        actions.openModal({
          modalName: "billing-modal",
        });
      }}
    >
      <PremiumUpgradeButtonIcon className="" />
      <span className="text-[8px] font-medium">Upgrade</span>
    </Button>
  );
};

export default PremiumUpgradeButton;
